import { initializeApp } from "@firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAlnQQLEvoyOBzgti93oQjaKmWPB7XpGmY",
  authDomain: "homeguru-2e379.firebaseapp.com",
  databaseURL:
    "https://homeguru-2e379-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "homeguru-2e379",
  storageBucket: "homeguru-2e379.appspot.com",
  messagingSenderId: "324379566092",
  appId: "1:324379566092:web:50e1ff91b9e60dac624e29",
  measurementId: "G-772N0RFKC8",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
